import { render, staticRenderFns } from "./CalificarProveedor.vue?vue&type=template&id=397e440d&scoped=true"
import script from "./CalificarProveedor.vue?vue&type=script&lang=js"
export * from "./CalificarProveedor.vue?vue&type=script&lang=js"
import style0 from "./CalificarProveedor.vue?vue&type=style&index=0&id=397e440d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397e440d",
  null
  
)

export default component.exports